import React from 'react';
import PropTypes from 'prop-types';
import InfoBox, {
  InfoBoxSpacer,
} from '../../../common/EnhancedGridFeature/InfoBox';
import MenuIcon from '../../ACShared/MenuIcon';
import { DeleteTarget } from './DeleteTarget';
// import EditNameTarget from './EditNameTarget';
import { DuplicateTarget } from './DuplicateTarget';
import EditExpressionTarget from './EditExpressionTarget';
import DeleteExpressionTarget from './DeleteExpressionTarget';
import {
  AC_PERSONAL_FOLDER_SCOPE,
  AC_SHARED_FOLDER_SCOPE,
  AC_GLOBAL_FOLDER_SCOPE,
} from '../../AutocodeConstants';

const TargetDefinationMenu = ({ item, fill, onDelete }) => {
  // const infoBoxRef = useRef(null);
  let menuClass = '';

  const buildInfoBox = () => {
    const acDef = [];
    if (
      item &&
      item.selectedFolder &&
      (item.selectedFolder.scope === AC_PERSONAL_FOLDER_SCOPE.value1 ||
        item.selectedFolder.scope === AC_PERSONAL_FOLDER_SCOPE.value2)
    ) {
      menuClass = 'autocode-personal-target-container';

      // acDef.push(<DuplicateTarget />);
      // acDef.push(<EditNameTarget />);
      acDef.push(<EditExpressionTarget />);
      acDef.push(<DeleteExpressionTarget onDelete={onDelete} />);
      // acDef.push(
      //   <InfoBoxSpacer Height="10px" boxClassName="ibox-spacer-hline" />
      // );

      // acDef.push(<DeleteTarget />);
      // setmenuArr(acDef);
    } else if (
      item &&
      item.selectedFolder &&
      (item.selectedFolder.scope === AC_SHARED_FOLDER_SCOPE.value1 ||
        item.selectedFolder.scope === AC_SHARED_FOLDER_SCOPE.value2)
    ) {
      menuClass = 'autocode-shared-target-container';
      acDef.push(<DuplicateTarget />);
      acDef.push(
        <InfoBoxSpacer Height="12px" boxClassName="ibox-spacer-hline" />
      );
      acDef.push(<DeleteTarget />);
    } else if (
      item &&
      item.selectedFolder &&
      (item.selectedFolder.scope === AC_GLOBAL_FOLDER_SCOPE.value1 ||
        item.selectedFolder.scope === AC_GLOBAL_FOLDER_SCOPE.value2)
    ) {
      menuClass = 'autocode-global-target-container';
      acDef.push(<DuplicateTarget />);
    }

    return acDef;
  };

  return (
    <span data-test="TargetDefinationMenu">
      <InfoBox
        // ref={infoBoxRef}
        Panels={buildInfoBox()}
        updatePanels={buildInfoBox}
        Positions={['bottom']}
        InfoBoxButtonInner={<MenuIcon fill={fill} />}
        Align="end"
        containerClassName={`autocode-definition-target-container ${menuClass}`}
      />
    </span>
  );
};

TargetDefinationMenu.propTypes = {
  item: PropTypes.shape({
    selectedFolder: PropTypes.shape({
      scope: PropTypes.number,
    }),
  }),
  fill: PropTypes.string,
  onDelete: PropTypes.func,
  // onEditName: PropTypes.func,
};

export default TargetDefinationMenu;
